// Declare global window properties for TypeScript
declare global {
  interface Window {
    manualLogout: () => void;
    clearAuthData: () => void;
  }
}

/**
 * Manual logout function to completely clear all authentication data
 * This function can be executed in the browser console to force a complete logout
 */
export function manualLogout() {
  // Clear localStorage items
  localStorage.removeItem('user');
  localStorage.removeItem('auth0.is.authenticated');
  localStorage.removeItem('auth0spa');
  
  // Clear sessionStorage items
  sessionStorage.removeItem('user');
  sessionStorage.removeItem('auth0.is.authenticated');
  sessionStorage.removeItem('auth0spa');
  
  // Clear all items that start with 'auth0'
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('auth0')) {
      localStorage.removeItem(key);
    }
  });
  
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith('auth0')) {
      sessionStorage.removeItem(key);
    }
  });
  
  // Clear all cookies that might be related to auth
  document.cookie.split(";").forEach(cookie => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
  });
  
  // Reload the page to ensure clean state
  window.location.href = '/';

}

// Also export a function to just clear the data without redirecting
export function clearAuthData() {
  // Clear localStorage items
  localStorage.removeItem('user');
  localStorage.removeItem('auth0.is.authenticated');
  localStorage.removeItem('auth0spa');
  
  // Clear sessionStorage items
  sessionStorage.removeItem('user');
  sessionStorage.removeItem('auth0.is.authenticated');
  sessionStorage.removeItem('auth0spa');
  
  // Clear all items that start with 'auth0'
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('auth0')) {
      localStorage.removeItem(key);
    }
  });
  
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith('auth0')) {
      sessionStorage.removeItem(key);
    }
  });

}